import React from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import './App.css';
import { translate } from "./utils";
import Container from 'react-bootstrap/Container';

const ButtonGroupMenu = (props) => {

  return <><div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
      }}
    >
      <Container>
      <ButtonGroup vertical>
      {/* <Button onClick={() => props.onClick('exhibitor')} className="menuItem spacing">{translate(props.appData, 'Exhibitor Booking Form')}</Button> */}
      {/* <Button onClick={() => props.onClick('adult')} className="menuItem spacing">{translate(props.appData, 'Adult Classes')}</Button> */}
        <Button onClick={() => props.onClick('volunteer')} className="menuItem spacing">{translate(props.appData, 'Volunteer at Al-Falah')}</Button>
        {/* <Button onClick={() => props.onClick('revision')} className="menuItem spacing">{translate(props.appData, 'Sign up for Quran Revision Day (February 15')}</Button> */}
        <Button onClick={() => props.onClick('giftaid')} className="menuItem spacing">{translate(props.appData, 'Sbmit your Gift Aid declaration')}</Button>
        <Button onClick={() => props.onClick('donate')} className="menuItem spacing">{translate(props.appData, 'Pledge a monthly donation')}</Button>
        <Button onClick={() => props.onClick('loan')} className="menuItem spacing">{translate(props.appData, 'Qive Qadr (ul) Hasna')}</Button>
        <Button onClick={() => props.onClick('onetime')} className="menuItem spacing">{translate(props.appData, 'Make a one-time donation')}</Button>
        <Button onClick={() => window.open('https://www.alfalahcentre.org/donation.pdf')} className="menuItem spacing">{translate(props.appData, 'Download standing order form')}</Button>        
      </ButtonGroup>
      </Container>    
  </div>
        <footer>{translate(props.appData,`Please contact <a href="mailto:info@alfalahcentre.org">info@alfalahcentre.org</a> for any queries. Please remember to fill out a Gift Aid form that can help us claim an additional 25% of your donation.`, true)}</footer>               
  </>
}

export default ButtonGroupMenu;
